/**
 * Available metric types for key results
 */
export const METRIC_TYPES = [
  { value: 'number', label: 'Número', example: 'Ex: 0 → 100' },
  { value: 'percentage', label: 'Porcentagem', example: 'Ex: 0% → 100%' },
  { value: 'currency', label: 'Moeda', example: 'Ex: R$ 0 → R$ 1.000.000' },
  { value: 'boolean', label: 'Sim/Não', example: 'Ex: Não concluído → Concluído' },
] as const;

/**
 * Validation error messages
 */
export const ERROR_MESSAGES = {
  TITLE_REQUIRED: 'Título é obrigatório',
  TITLE_MIN_LENGTH: 'Título deve ter pelo menos 10 caracteres',
  TITLE_MAX_LENGTH: 'Título deve ter no máximo 100 caracteres',
  DESCRIPTION_MAX_LENGTH: 'Descrição deve ter no máximo 500 caracteres',
  METRIC_TYPE_REQUIRED: 'Tipo de métrica é obrigatório',
  INITIAL_VALUE_REQUIRED: 'Valor inicial é obrigatório',
  TARGET_VALUE_REQUIRED: 'Valor alvo é obrigatório',
  VALUES_MUST_DIFFER: 'Valor inicial e valor alvo devem ser diferentes',
  PERCENTAGE_RANGE: 'Valores devem estar entre 0 e 100 para tipo percentual',
  START_DATE_REQUIRED: 'Data de início é obrigatória',
  TARGET_DATE_REQUIRED: 'Data alvo é obrigatória',
  DATE_ORDER: 'Data alvo deve ser posterior à data de início',
  RESPONSIBLE_REQUIRED: 'Responsável é obrigatório',
  MAX_KR_EXCEEDED: 'Limite de Key Results atingido', // No longer enforced - kept for backward compatibility
  INVALID_OBJECTIVE_STATUS: 'Key Results só podem ser criados em objetivos ativos ou em rascunho',
} as const;

/**
 * Form field default values
 */
export const DEFAULT_FORM_VALUES = {
  title: '',
  description: '',
  metricType: 'number' as const,
  unit: '',
  initialValue: 0,
  targetValue: 100,
  currentValue: undefined,
  startDate: new Date(),
  targetDate: new Date(new Date().setMonth(new Date().getMonth() + 3)),
  responsibleId: '',
  responsibleName: '',
  responsibleEmail: '',
};
